import { Navigate } from 'react-router-dom'
import { ApplicationPaths, QueryParameterNames } from './ApiAuthorizationConstants'

export default function AuthorizeRoute(props: { path?: any; isAppLoading?: any; isAuthenticated?: any; element?: any; }) {
  var link = document.createElement("a");
  link.href = props.path;
  
  const returnUrl = `${link.pathname}${link.search}${link.hash}`;
  const redirectUrl = `${ApplicationPaths.Login}?${QueryParameterNames.ReturnUrl}=${encodeURIComponent(returnUrl)}`;
  
  if (props.isAppLoading) {
    return <div></div>;
  } else {
    const { element } = props;
    return props.isAuthenticated ? element : <Navigate to={redirectUrl} />;
  }
}
